import { useMemo, useState } from "react";
import { selectCommunicationData } from "../../store";
import { useAppSelector } from "../../store/hooks";
import { Vspace } from '../../components/styled/Separators.style'
import PageContainerCmp from "./../PageContainerCmp";
import { RealtimeModal } from "../../components/modal/RealtimeModal";
import { LINEAR_BASE_ROUTE, LINEAR_PATHS } from "../../routes/linearRouteConstants";
import { LPageTitle, LSimpleText, LSimpleTextSmall } from "../../components/styled/Text.style";
import { LNextButton, SecondChoiseButton, } from "../../components/styled/Button.style";
import { Section } from "../../components/styled/Containers.style";
import LinearFooterCmp from "../../components/footer/LinearFooter";
import { LinearInfoModal } from "../../components/cai-info-modal/LinearInfoModal";
import { checkDimensionsFileAdded, composeUrl, getListOfOnusSentFileIds } from "../../utils/utils";
import { useNavigate } from "react-router-dom";
import LinearPhone from './../../assets/img/linearPhone.svg'
import { EventCommType, EventValueEnum, FileItemType } from "../../types/communication/communicationDataType";
import FilesUploadListCmp from "../../components/file/FilesUploadListCmp";
import SinistroCardLinear from "../../components/cards/SinistroCardLinear";
import { LinearHelpRequestText } from "./LinearHelpRequestText";
import { saveCommunicationAct } from "../../store/communication-data/actions";
import { useDispatch } from "react-redux";

const RequireDenunciaPageLinear = () => {
    const dispatch = useDispatch();
    const [openHelpModal, setOpenHelpModal] = useState(false)
    const communicationData = useAppSelector(selectCommunicationData)
    const navigate = useNavigate();
    const { communication } = communicationData
    const { token } = communication;

    const [denunciaDocsList, setDenunciaDocsList] = useState<FileItemType[]>(communication.denunciaDocsList)

    const goToNextStepHandler = () => {
        const resultEvent = new EventCommType({ value: EventValueEnum.LINEAR_UPLOADED_COMPLAIN_AND_PROCEED });
        const nextPath = composeUrl(token, LINEAR_PATHS.OPTIONAL_DOCUMENTS_PAGE, LINEAR_BASE_ROUTE)
        dispatch(saveCommunicationAct({
            events: [resultEvent],
            callback: () => navigate(nextPath)
        }))
    }

    const alreadySentDocIds = useMemo(() => getListOfOnusSentFileIds(communication),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [communication?.token])

    const goToHelp = () => {
        setOpenHelpModal(true)
    }

    return (
        <>

            <RealtimeModal
                companyName={communication?.companyName}
                modalOpened={openHelpModal}
                hTitle="CONTATTACI"
                hCloseButton={true}
                /* istanbul ignore next */
                onCloseHandler={() => setOpenHelpModal(false)}>
                <LinearInfoModal
                    close={() => setOpenHelpModal(false)}
                    additionalImage={LinearPhone}
                    text={<LinearHelpRequestText />}
                />
            </RealtimeModal>

            <PageContainerCmp
                nextStepHandler={goToNextStepHandler}
                routePath={LINEAR_PATHS.REQUIRE_DENUNCIA_PAGE}
                removeNextBtn
            >

                <Section linear={true}>

                    <SinistroCardLinear />

                    <Vspace qty={2}></Vspace>

                    <LPageTitle>DENUNCIA FIRMATA</LPageTitle>
                    <Vspace qty={0.2}></Vspace>
                    <LSimpleTextSmall style={{ width: "100%" }}>Max 2 file</LSimpleTextSmall>

                    <Vspace qty={2}></Vspace>

                    <LSimpleText>Nella denuncia descrivi come e quando è avvenuto l’incidente, indica le targhe e i dati di chi era alla guida. <strong style={{ color: "#575757" }}>Ricordati di firmare il documento che carichi. Per comodità puoi utilizzare un modulo CAI</strong>.</LSimpleText>

                    <Vspace qty={2}></Vspace>

                    <FilesUploadListCmp
                        files={denunciaDocsList}
                        setFiles={setDenunciaDocsList}
                        fileType={"SIGNED-COMPLAINT"}
                        arrayDbPropSync={"denunciaDocsList"}
                        companyName={communication?.companyName}
                        maxLimit={2}
                        alreadySentDocIds={alreadySentDocIds}
                        onPreUploadCallback={checkDimensionsFileAdded}
                    />

                </Section>

                <Vspace qty={2}></Vspace>

                <Section linear={true}>
                    <LNextButton disabled={denunciaDocsList?.length === 0} onClick={goToNextStepHandler}>PROCEDI</LNextButton>
                    <Vspace qty={2}></Vspace>
                    <SecondChoiseButton linear={true} onClick={goToHelp}>Hai bisogno di aiuto?</SecondChoiseButton>
                </Section>

                <LinearFooterCmp />

            </PageContainerCmp>
        </>

    )
}

export default RequireDenunciaPageLinear